<script>
import { Bar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default Bar.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  },
});
</script>



// WEBPACK FOOTER //
// BaseBarChart.vue?39f20f80